import { CommonEnums } from '../common.enums';

export class DIMsgObj {
    retMsgObject: any;
    retMsgObjects: Array<any>;
    retGridObjects: Array<any>;
    persistVal: any;
    oidc_tokens?: any;
    refFlg: string;
    error_Cd: any;
    error_Msg: string;
    infoMessage: string;
    fileName: string;
    cleanupFlg: string;

    constructor() {
        this.retMsgObject = {};
        this.retMsgObjects = new Array<any>();
        this.retGridObjects = new Array<any>();
        this.persistVal = {};
        this.oidc_tokens = {};
        this.refFlg = CommonEnums.defaults.STRING_EMPTY;
        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
    }
}